import { RootLayerType } from "./RootLayerType";

/**
 * 地物タイプを現すenum
 */
export enum FeatureType {
  Bridges = "道路橋",
  Tunnels = "トンネル",
  Sheds = "シェッド",
  Culverts = "大型カルバート",
  PedestrianDecks = "横断歩道橋",
  OverheadSignages = "門型標識等",
  Pavements = "舗装",
  Earthworks = "特定道路土工構造物",
  Signages = "標識",
  Lightings = "照明の基礎情報",

  DrmNode = "DRMノード",
  DrmLink = "DRMリンク",

  ODArrivalNode = "OD属性表示画面（量OD-着ノード情報）",
  ODNode = "OD属性表示画面（量OD-ノード情報）",
  ODRangeNode = "量OD-市区町村指定出力用",

  ODDeparture = "OD属性表示画面（発生量）",
  ODArrival = "OD属性表示画面（集中量）",
  ODDepartureAndArrival = "OD属性表示画面（発生集中量）",

  TraVosCalc5MinRealTimeAttribute = "TraVosリアルタイム属性表示画面（計測値5分）",
  TraVosCalcHourRealTimeAttribute = "TraVosリアルタイム属性表示画面（計測値1時間）",
  TraVosCCDFiveMinRealTimeAttribute = "TraVosリアルタイム属性表示画面（計測値5分）（画像認識型）",
  TraVosCCDHourRealTimeAttribute = "TraVosリアルタイム属性表示画面（計測値1分）（画像認識型）",
  TraVosCalc5MinRealTimeTraffic = "TraVosリアルタイム交通量表示画面（計測値5分）",
  TraVosCalcHourRealTimeTraffic = "TraVosリアルタイム交通量表示画面（計測値1時間）",
  TraVosCCDFiveMinRealTimeTraffic = "TraVosリアルタイム交通量表示画面（計測値5分）（画像認識型）",
  TraVosCCDHourRealTimeTraffic = "TraVosリアルタイム交通量表示画面（計測値1時間）（画像認識型）",
  TraVosCalcFiveMinSearchDateAttribute = "TraVos過去属性表示画面（計測値5分）",
  TraVosCalcHourSearchDateAttribute = "TraVos過去属性表示画面（計測値1時間）",
  TraVosCCDFiveMinSearchDateAttribute = "TraVos過去属性表示画面（計測値5分）（画像認識型）",
  TraVosCCDHourSearchDateAttribute = "TraVos過去属性表示画面（計測値1時間）（画像認識型）",
  TraVosFixHourSearchDateAttribute = "TraVos過去属性表示画面（確定値1時間）",
  TraVosFixCCDHourSearchDateAttribute = "TraVos過去属性表示画面（確定値1時間）（画像認識型）",
  TraVosLinkSearchDateAttributeConvert = "TraVos過去属性表示画面（交通基本区間）",

  ETCDrmFifteenMin = "ETC2.0属性(DRM 区間-15 分)",
  ETCDrmHour = "ETC2.0属性(DRM 区間-1時間)",
  ETCDrmMonth = "ETC2.0属性(DRM 区間-1ヵ月)",
  ETCLinkFifteenMin = "ETC2.0属性(交通調査基本区間-15 分)",
  ETCLinkHour = "ETC2.0属性(交通調査基本区間-1時間)",
  EtcLinkMonth = "ETC2.0属性(交通調査基本区間-1ヵ月)",

  CCTVDirectControl = "CCTV（直轄）",

  GeoJson = "GeoJSON",
}

const enumKeys = Object.keys(FeatureType);
const enumValues = Object.values(FeatureType);

/**
 * 地物タイプからenumのkey名を取得
 * @param FeatureType 地物タイプ
 */
export const getFeatureTypeKey = (FeatureType: string) => {
  const index = enumValues.indexOf(FeatureType as FeatureType);
  if (index >= 0) {
    return enumKeys[index] as string;
  }
  return null;
};

/**
 * 最上位項目の種別からそこに属する地物タイプを取得
 * @param rootLayerType
 * @returns
 */
export const getFeatureTypeListByRootLayerType = (
  rootLayerType: RootLayerType
) => {
  switch (rootLayerType) {
    case RootLayerType.Travos:
      return [
        FeatureType.TraVosCalc5MinRealTimeAttribute,
        FeatureType.TraVosCalcHourRealTimeAttribute,
        FeatureType.TraVosCCDFiveMinRealTimeAttribute,
        FeatureType.TraVosCCDHourRealTimeAttribute,
        FeatureType.TraVosCalc5MinRealTimeTraffic,
        FeatureType.TraVosCalcHourRealTimeTraffic,
        FeatureType.TraVosCCDFiveMinRealTimeTraffic,
        FeatureType.TraVosCCDHourRealTimeTraffic,
        FeatureType.TraVosCalcHourSearchDateAttribute,
        FeatureType.TraVosCCDHourSearchDateAttribute,
      ];
    case RootLayerType.Etc:
      return [
        FeatureType.ETCDrmFifteenMin,
        FeatureType.ETCDrmHour,
        FeatureType.ETCDrmMonth,
        FeatureType.ETCLinkFifteenMin,
        FeatureType.ETCLinkHour,
        FeatureType.EtcLinkMonth,
      ];
    case RootLayerType.Od:
      return [
        FeatureType.ODArrivalNode,
        FeatureType.ODNode,
        FeatureType.ODRangeNode,
        FeatureType.ODDeparture,
        FeatureType.ODArrival,
        FeatureType.ODDepartureAndArrival,
      ];
    case RootLayerType.RoadStructures:
      return [
        FeatureType.Bridges,
        FeatureType.Tunnels,
        FeatureType.Sheds,
        FeatureType.Culverts,
        FeatureType.PedestrianDecks,
        FeatureType.OverheadSignages,
        FeatureType.Pavements,
        FeatureType.Earthworks,
      ];
    case RootLayerType.Drm:
      return [FeatureType.DrmLink, FeatureType.DrmNode];
  }
};

/**
 * ファイル出力可能な地物タイプをサイドメニュー順に全取得
 */
export const getExportableFeatureType = () => {
  return [
    // TraVoS
    FeatureType.TraVosCalcHourSearchDateAttribute,
    FeatureType.TraVosCCDHourSearchDateAttribute,
    FeatureType.TraVosCalc5MinRealTimeAttribute,
    FeatureType.TraVosCCDFiveMinRealTimeAttribute,
    FeatureType.TraVosCalcHourRealTimeAttribute,
    FeatureType.TraVosCCDHourRealTimeAttribute,
    // OD
    FeatureType.ODNode,
    FeatureType.ODArrivalNode,
    FeatureType.ODDeparture,
    FeatureType.ODArrival,
    FeatureType.ODDepartureAndArrival,
  ];
};
